import {push} from 'react-router-redux';
import {actionFactory} from '../util/redux-helpers';

export const ACTIONS = {
  CompanySelected: 'NAV_COMPANY_SELECTED'
};

export const SelectCompany = actionFactory(ACTIONS.CompanySelected);

export function SelectCompanyEpic(companyId) {
  return async (dispatch) => {
    dispatch(SelectCompany(companyId));
    if (companyId) {
      dispatch(push(`/company/${companyId}/locations`));
    } else {
      dispatch(push(`/companies`));
    }
  };
}



// WEBPACK FOOTER //
// ./src/actions/nav.actions.js